document.addEventListener('DOMContentLoaded', function () {
  const preloader = document.getElementById('preloader');
  const percentageText = document.getElementById('loading-percentage');
  const images = document.images;
  const totalImages = images.length;
  let imagesLoaded = 0;

  if (totalImages === 0) {
    percentageText.textContent = '100%';
    preloader.remove();
  }

  const updateProgress = () => {
    imagesLoaded++;
    const percent = Math.round((imagesLoaded / totalImages) * 100);
    percentageText.textContent = `${percent}%`;

    if (imagesLoaded === totalImages) {
      setTimeout(() => {
        preloader.style.opacity = '0';
        preloader.style.pointerEvents = 'none';
        setTimeout(() => preloader.remove(), 300);
      }, 300);
    }
  };

  for (let i = 0; i < totalImages; i++) {
    const img = new Image();
    img.onload = updateProgress;
    img.onerror = updateProgress;
    img.src = images[i].src;
  }
});